document.addEventListener('DOMContentLoaded', function() {
  textFill(".youtube-thumb-subtitle", { maxFontPixels: 140 });
  textFill(".youtube-thumb-main-title", { maxFontPixels: -1 });
});
